module.exports = "/packs/images/homepage/facilities/childrens_centres_tablet~626edac25394b4158388c6f5eb60f4ab.jpg";